import classNames from 'classnames'
import React, { useCallback, useMemo } from 'react'
import SimpleBar from 'simplebar-react'

import { HomeManualFieldProjection, Icons, Sections, SetStateType } from '../../definitions'
import useSetFirstActiveSectionTitle from '../../hooks/useSetFirstActiveSectionTitle'
import MarkdownPreview from '../MarkdownPreview'

import style from './style.module.css'
import { getSectionContent } from '../../utils/getters'

type ManualSectionsProps = {
  sections: Sections
  activeSectionTitle?: string
  setState: SetStateType
}

function ManualSections({ sections, activeSectionTitle, setState }: ManualSectionsProps) {
  const handleSetState = useCallback(
    (nextSection: HomeManualFieldProjection) => () => {
      setState(nextSection)
    },
    [setState]
  )

  const filledSections = useMemo(() => sections.filter(section => getSectionContent(section)), [
    sections,
  ])

  const renderManualSections = useMemo(() => {
    return filledSections.map((section, key) => {
      const itemClassNames = classNames({
        [style.active]: section.title === activeSectionTitle,
      })

      const Icon = Icons[section.key] || Icons.defaultSection

      return (
        <li key={key} onClick={handleSetState(section)}>
          <button className={itemClassNames} data-testid="section-btn">
            <span>
              <div className={style.icon}>
                <Icon className={style.iconImage} />
              </div>
              {section.title}
            </span>
            <i className={style.arrow} />
          </button>

          <div className={`${style.printPreview} ${style.onlyPrint}`}>
            <MarkdownPreview source={getSectionContent(section)} />
          </div>
        </li>
      )
    })
  }, [filledSections, activeSectionTitle, handleSetState])

  useSetFirstActiveSectionTitle({
    setState,
    activeSectionTitle,
    sections: filledSections,
  })

  return (
    <nav className={style.container}>
      <div className={style.lightGradient} />
      <SimpleBar className={style.simpleBar}>
        <ul className={style.section}>{renderManualSections}</ul>
      </SimpleBar>
      <ul className={`${style.section} ${style.onlyPrint}`}>{renderManualSections}</ul>
    </nav>
  )
}

export default ManualSections
